import { inject, Pipe, PipeTransform } from '@angular/core';
import { ProfanityService } from '../services/utility/profanity/profanity.service';
import { isNullOrEmptyString } from '../utilities/compare';

@Pipe({
	name: 'profanityMask',
})
export class ProfanityMaskPipe implements PipeTransform {
	private readonly profanityService = inject(ProfanityService);

	transform(value: string | null | undefined): string | null | undefined {
		if (isNullOrEmptyString(value)) {
			return value;
		} else {
			return this.profanityService.censor(value);
		}
	}
}
